import { DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxSelectBoxModule, DxButtonModule, DxTextAreaModule, DxCheckBoxModule, DxDropDownBoxModule, DxDataGridModule } from 'devextreme-angular';
import { PostTextEditorModule } from './../post-text-editor/post-text-editor.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewPostPopupComponent } from './new-post-popup.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
	declarations: [NewPostPopupComponent],
	exports: [NewPostPopupComponent],
  imports: [
		CommonModule,
		ReactiveFormsModule,
		PostTextEditorModule,
		DxPopupModule,
		DxScrollViewModule,
		DxTextBoxModule,
		DxSelectBoxModule,
		DxButtonModule,
		DxTextAreaModule,
		DxCheckBoxModule,DxDropDownBoxModule,DxDataGridModule
  ]
})
export class NewPostPopupModule { }
